import { useState, useEffect } from 'react';

interface Coin {
  id: string;
  symbol: string;
  current_price: number;
  price_change_percentage_24h: number;
  image: string;
}

export const TopMovers: React.FC = () => {
  const [gainers, setGainers] = useState<Coin[]>([]);
  const [losers, setLosers] = useState<Coin[]>([]);
  const [tab, setTab] = useState<'gainers' | 'losers'>('gainers');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=50&page=1&price_change_percentage=24h'
        );
        const data: Coin[] = await res.json();
        if (!Array.isArray(data)) return;
        const sorted = [...data]
          .filter((c) => c.price_change_percentage_24h != null)
          .sort((a, b) => b.price_change_percentage_24h - a.price_change_percentage_24h);
        setGainers(sorted.slice(0, 5));
        setLosers([...sorted].reverse().slice(0, 5));
      } catch {
        // silent
      }
    };
    load();
  }, []);

  if (gainers.length === 0) return null;

  const coins = tab === 'gainers' ? gainers : losers;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-bold mb-3">Maiores Movimentos 24h</h3>
      <div className="flex gap-2 mb-4">
        <button
          onClick={() => setTab('gainers')}
          className={`px-3 py-1 text-xs rounded-full font-semibold transition ${
            tab === 'gainers' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
          }`}
        >
          Altas
        </button>
        <button
          onClick={() => setTab('losers')}
          className={`px-3 py-1 text-xs rounded-full font-semibold transition ${
            tab === 'losers' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
          }`}
        >
          Baixas
        </button>
      </div>
      <div className="space-y-2.5">
        {coins.map((coin) => {
          const pct = coin.price_change_percentage_24h;
          const price = coin.current_price >= 1
            ? coin.current_price.toLocaleString('en-US', { maximumFractionDigits: 2 })
            : coin.current_price.toFixed(5);
          return (
            <div key={coin.id} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <img src={coin.image} alt={coin.symbol} className="w-5 h-5 rounded-full" />
                <span className="text-sm font-semibold">{coin.symbol.toUpperCase()}</span>
                <span className="text-xs text-gray-400">${price}</span>
              </div>
              <span className={`text-sm font-bold ${pct >= 0 ? 'text-green-600' : 'text-red-500'}`}>
                {pct >= 0 ? '+' : ''}{pct.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-gray-400 mt-3 text-center">Fonte: CoinGecko</p>
    </div>
  );
};
